appHost.actions.register({
    // #region Vars
    name: '288a.layouts.layout.showrawdata',
    // #endregion
    // #region Entry
    async execute(data, params) {
        // #region Check
        if (!data) {
            return this.Cancel();
        }
        // #endregion
        // #region Schema
        let tSchema = {
            "window": {
                "title": this.$appHost.localizer.t('client.Common.ShowRawData') + '...'
            },
            "data": {
                "rawData@comp.exp": "props.args.dataJson",
                "rawProps@comp.exp": "props.args.propsJson",
                "rawAttrs@comp.exp": "props.args.attrsJson",
            },
            "layout": {
                "fieldType": "element-root",
                "fields": [
                    {
                        "fieldType": "element-content",
                        "header": {
                            "fields": [
                                {
                                    "fieldType": "header_bar",
                                    "attributes": {
                                        "class": "p-3"
                                    },
                                    "hideCloseButton": false,
                                    "title": {
                                        "fieldType": "label",
                                        "text": this.$appHost.localizer.t('client.Common.ShowRawData') + '...'
                                    },
                                    "commands": {
                                        "fields": [
                                            {
                                                "fieldType": "header_dropdown",
                                                "showSystemCommands": true,
                                                "imageName": "/assets/icons/three-dots-vertical.svg"
                                            }
                                        ]
                                    }
                                }
                            ]
                        },
                        "content": {
                            "fields": [
                                {
                                    "fieldType": "g-layout__field-form",
                                    "fields": [
                                        {
                                            "fieldType": "tabs",
                                            "fields": [
                                                {
                                                    "name": "rawdata",
                                                    "fieldType": "tab_page",
                                                    "attributes": {
                                                        "class": "p-2"
                                                    },
                                                    "label": {
                                                        "fieldType": "label",
                                                        "text": this.$appHost.localizer.t('client.Common.RawData')
                                                    },
                                                    "fields": [
                                                        {
                                                            "fieldType": "layout-columns",
                                                            "height": "fill",
                                                            "fields": [
                                                                {
                                                                    "label": this.$appHost.localizer.t('client.Common.Content'),
                                                                    "fieldType": "fields",
                                                                    "attributes": {
                                                                        "justified": true
                                                                    },
                                                                    "fields": [
                                                                        {
                                                                            "name": "content",
                                                                            "dataMember": "rawData",
                                                                            "fieldType": "entry_syntax",
                                                                            "readOnly": true,
                                                                            "attributes": {
                                                                                "language": "json"
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "properties",
                                                    "fieldType": "tab_page",
                                                    "attributes": {
                                                        "class": "p-2"
                                                    },
                                                    "label": {
                                                        "fieldType": "label",
                                                        "text": this.$appHost.localizer.t('client.Common.Properties'),
                                                    },
                                                    "fields": [
                                                        {
                                                            "fieldType": "layout-columns",
                                                            "height": "fill",
                                                            "fields": [
                                                                {
                                                                    "label": this.$appHost.localizer.t('client.Common.Content'),
                                                                    "fieldType": "fields",
                                                                    "attributes": {
                                                                        "justified": true
                                                                    },
                                                                    "fields": [
                                                                        {
                                                                            "name": "content",
                                                                            "dataMember": "rawProps",
                                                                            "fieldType": "entry_syntax",
                                                                            "readOnly": true,
                                                                            "attributes": {
                                                                                "language": "json"
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                ,
                                                {
                                                    "name": "attrs",
                                                    "fieldType": "tab_page",
                                                    "attributes": {
                                                        "class": "p-2"
                                                    },
                                                    "label": {
                                                        "fieldType": "label",
                                                        "text": this.$appHost.localizer.t('client.Common.Attribute'),
                                                    },
                                                    "fields": [
                                                        {
                                                            "fieldType": "layout-columns",
                                                            "height": "fill",
                                                            "fields": [
                                                                {
                                                                    "label": this.$appHost.localizer.t('client.Common.Content'),
                                                                    "fieldType": "fields",
                                                                    "attributes": {
                                                                        "justified": true
                                                                    },
                                                                    "fields": [
                                                                        {
                                                                            "name": "content",
                                                                            "dataMember": "rawAttrs",
                                                                            "fieldType": "entry_syntax",
                                                                            "readOnly": true,
                                                                            "attributes": {
                                                                                "language": "json"
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        "footer": {
                            "fields": [
                                {
                                    "fieldType": "footer_bar",
                                    "right": {
                                        "attributes": {
                                            "class": "gap-2"
                                        },
                                        "fields": [
                                            {
                                                "fieldType": "button",
                                                "buttonStyle": "btn-outline-secondary",
                                                "label": {
                                                    "fieldType": "label",
                                                    "text": this.$appHost.localizer.t('shared.Text.Close'),
                                                },
                                                "command": {
                                                    "name": "close"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        };
        // #endregion
        // #region Args
        var tData = {
            layoutSchema: tSchema,
            args: data,
        };
        let tProps = {
            variant: "slide",
            position: "end",
            size: "large",
            closeOnKeyEsc: false,
            closeOnOutsideClick: false
        };
        // #endregion
        // #region Show
        await this.$appHost.notification.showModal2("g-layout__layout-common", tData, tProps);
        // #endregion        
        return this.Ok();
    },
    // #endregion
});
export {};
